import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react"
import { handlingErrorResponse } from "utils/HandlingErrorResponse"
import { baseUrl } from "constant"
import { RootState } from "store/store"
import { getAuthToken } from "utils/getAuthToken"
import { HolidayEndpointConst, getHolidayById } from "./const"
import {
    HolidayFilter, HolidayInfo, IDeleteHolidayById, IGetHolidayById, IHolidayResponsesType,
    IPaginationResponseType,
    IResponseType, IUpdateStatusType
} from "../types"

export const holidayApi = createApi({
    reducerPath: 'holidayApi',
    baseQuery: fetchBaseQuery({
        baseUrl: baseUrl,
        prepareHeaders: (headers, { getState }) => {
            const token = getAuthToken(getState() as RootState)
            if (token) {
                headers.set('Authorization', `Bearer ${token}`)
            }
            return headers
        },
    }),
    tagTypes: ['Holiday'],
    endpoints: (builder) => ({
        GetHolidays: builder.mutation<IPaginationResponseType<IHolidayResponsesType[]>, HolidayFilter>({
            query: (userReq) => ({
                url: HolidayEndpointConst.getHolidays,
                method: 'POST',
                body: userReq
            }),
            transformErrorResponse: handlingErrorResponse,
            invalidatesTags: [{ type: 'Holiday', id: 'Holiday' }],
        }),
        GetHolidayById: builder.query<IResponseType<IHolidayResponsesType>, IGetHolidayById>({
            query: (id) => ({
                url: getHolidayById(id.id),
                method: 'GET',
            }),
            transformErrorResponse: handlingErrorResponse,
            providesTags: [{ type: 'Holiday', id: 'Holiday' }],
        }),
        AddEditHoliday: builder.mutation<IResponseType<IHolidayResponsesType>, HolidayInfo>({
            query: holiday => ({
                url: HolidayEndpointConst.addEditHoliday,
                method: 'POST',
                body: holiday.holidayInfoObj
            }),
            transformErrorResponse: handlingErrorResponse,
            invalidatesTags: [{ type: 'Holiday', id: 'Holiday' }]
        }),
        DeleteHoliday: builder.mutation<IResponseType<boolean>, IDeleteHolidayById>({
            query: (id) => ({
                url: HolidayEndpointConst.deleteHoliday,
                method: 'DELETE',
                body: id.id,
            }),
            transformErrorResponse: handlingErrorResponse,
            invalidatesTags: [{ type: 'Holiday', id: 'Holiday' }]
        }),
        UpdateHolidayStatus: builder.mutation<IResponseType<boolean>, IUpdateStatusType>({
            query: holidayStatus => ({
                url: HolidayEndpointConst.updateHolidayStatus,
                method: 'PUT',
                body: holidayStatus
            }),
            transformErrorResponse: handlingErrorResponse,
            invalidatesTags: [{ type: 'Holiday', id: 'Holiday' }]
        }),
    }),
})